import React, { useEffect } from "react";
import CustomCard from "../../components/cards/CustomCard";
import {
  Avatar,
  Box,
  Divider,
  Flex,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import CustomButton from "../../components/buttons/CustomButton";
import CustomText from "../../components/text/CustomText";
import IconJpg from "../../svgs/IconJpg";
import InviteCard from "./InviteCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoginData } from "../../redux/actions/auth.actions";

function Dashboard() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { user, uid } = useSelector((state: any) => state.authUser);

  useEffect(() => {
    dispatch(getLoginData(uid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  useEffect(() => {
    if (user && !user?.companyInfo) {
      navigate("/onboarding");
    } else if (user && user?.status !== "APPROVED") {
      navigate("/kyc-pending");
    } else if (user && !user?.isPaymentCompleted) {
      navigate("/kyc-pending");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <>
      <CustomCard>
        <Flex gap="40px">
          <Box w="100%">
            <Box
              pos="relative"
              bg="yess.secondary_gold"
              borderRadius="16px"
              h="160px"
              w="100%"
              overflow="hidden"
            >
              <Box
                overflow="hidden"
                pos="absolute"
                bg="rgba(255, 255, 255, 0.20)"
                h="352px"
                w="352px"
                borderRadius="352px"
                right="0"
                top="0"
                mt="-80px"
                mr="-80px"
              >
                <Box
                  pos="absolute"
                  bg="rgba(255, 255, 255, 0.20)"
                  h="352px"
                  w="352px"
                  borderRadius="352px"
                  right="0"
                  top="0"
                  mt="0px"
                  mr="-30px"
                ></Box>
              </Box>
            </Box>
            <Flex justify="space-between" align="flex-end">
              {!user ? (
                <SkeletonCircle size="115px" mt="-50px" ml="20px" />
              ) : (
                <Avatar
                  src={user?.profileImg}
                  name={user?.personalInfo?.name}
                  boxSize="115px"
                  bg="yess.secondary_gold"
                  border="5px solid #F2F2F2"
                  mt="-50px"
                  ml="20px"
                />
              )}
              {/* <CustomButton
                btnTitle="Edit"
                maxW="70px"
                height="32px"
                size="12px"
                weight="400"
              /> */}
            </Flex>
            <Flex mt="24px" gap="16px" align="center">
              {!user ? (
                <SkeletonText noOfLines={1} w="200px" />
              ) : (
                <CustomText
                  text={user?.personalInfo?.name || ""}
                  size="24px"
                  weight="700"
                  color="yess.base_black"
                />
              )}
              {!user ? (
                <SkeletonText noOfLines={1} w="140px" />
              ) : (
                <Flex
                  align="center"
                  justify="center"
                  w="98px"
                  h="26px"
                  borderRadius="99px"
                  bg="#2EC19E"
                >
                  <CustomText
                    text={user?.status}
                    size="12px"
                    weight="400"
                    color="#fff"
                  />
                </Flex>
              )}
            </Flex>
            <Flex gap="24px" mt="24px">
              <Flex flexDir="column" gap="12px" maxW="352px" w="100%">
                <CustomText
                  text="Personal Info"
                  size="14px"
                  weight="700"
                  color="yess.neutral700"
                />
                <Flex
                  p="24px"
                  flexDir="column"
                  gap="16px"
                  bg="rgba(242, 242, 242, 0.50)"
                  borderRadius="16px"
                  w="100%"
                >
                  <Flex align="center" justify="space-between">
                    <CustomText text="Name" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={user?.personalInfo?.name}
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="Nationality" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={user?.personalInfo?.nationality}
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="DOB" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={user?.personalInfo?.dateOfBirth}
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                </Flex>
              </Flex>
              <Flex flexDir="column" gap="12px" w="100%">
                <CustomText
                  text="About Event"
                  size="14px"
                  weight="700"
                  color="yess.neutral700"
                />
                <Flex
                  p="24px"
                  flexDir="column"
                  gap="16px"
                  bg="rgba(242, 242, 242, 0.50)"
                  borderRadius="16px"
                  w="100%"
                >
                  <Flex align="center" justify="space-between">
                    <CustomText text="Event Name" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text="World Defence Show"
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="Date & Time" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text="05 Feb, 2025 10:30AM"
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="Venue" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text="Mecca Saudi Arabia"
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
            <Flex gap="24px" mt="24px">
              <Flex flexDir="column" gap="12px" maxW="352px" w="100%">
                <CustomText
                  text="Contact Info"
                  size="14px"
                  weight="700"
                  color="yess.neutral700"
                />
                <Flex
                  p="24px"
                  flexDir="column"
                  gap="16px"
                  bg="rgba(242, 242, 242, 0.50)"
                  borderRadius="16px"
                  w="100%"
                >
                  <Flex align="center" justify="space-between">
                    <CustomText text="Phone No" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={user?.personalInfo?.personalPhone}
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="Email" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={
                          user?.personalInfo?.email
                            ? user?.personalInfo?.email
                            : "N/A"
                        }
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                  <Divider bg="#C1C2C4" />
                  <Flex align="center" justify="space-between">
                    <CustomText text="Address" color="yess.neutral500" />
                    {!user ? (
                      <SkeletonText noOfLines={1} w="120px" />
                    ) : (
                      <CustomText
                        text={user?.personalInfo?.personalAddress}
                        color="yess.neutral800"
                      />
                    )}
                  </Flex>
                </Flex>
              </Flex>
              <Flex flexDir="column" gap="12px" w="100%">
                <CustomText
                  text="Submitted Documents"
                  size="14px"
                  weight="700"
                  color="yess.neutral700"
                />
                {!user ? (
                  <Flex gap="24px">
                    {new Array(3)?.fill(1)?.map((_, index) => (
                      <Flex
                        p="16px 24px"
                        flexDir="column"
                        align="center"
                        gap="12px"
                        bg="rgba(242, 242, 242, 0.50)"
                        borderRadius="16px"
                        w="100%"
                        h="100%"
                        key={index}
                      >
                        <SkeletonCircle size="48px" />
                        <SkeletonText noOfLines={1} w="120px" />
                        <SkeletonText noOfLines={1} w="120px" />
                      </Flex>
                    ))}
                  </Flex>
                ) : (
                  <Flex gap="24px">
                    <Flex
                      p="16px 24px"
                      flexDir="column"
                      align="center"
                      gap="12px"
                      bg="rgba(242, 242, 242, 0.50)"
                      borderRadius="16px"
                      w="100%"
                    >
                      <Flex
                        h="48px"
                        w="48px"
                        bg="#F2F2F2"
                        borderRadius="12px"
                        align="center"
                        justify="center"
                      >
                        <IconJpg />
                      </Flex>
                      <Flex flexDir="column" gap="2px" align="center">
                        <CustomText
                          text="Passport_file0027.jpg"
                          size="14px"
                          color="yess.neutral700"
                        />
                        <CustomText
                          text="12 Kbs"
                          size="12px"
                          color="yess.neutral500"
                        />
                      </Flex>
                      <CustomButton
                        btnTitle="View"
                        maxW="79px"
                        height="32px"
                        bg="#EDF3FF"
                        border="1px solid"
                        borderColor="#387DF5"
                        radius="8px"
                        color="#387DF5"
                        size="14px"
                        weight="400"
                      />
                    </Flex>
                    <Flex
                      p="16px 24px"
                      flexDir="column"
                      align="center"
                      gap="12px"
                      bg="rgba(242, 242, 242, 0.50)"
                      borderRadius="16px"
                      w="100%"
                    >
                      <Flex
                        h="48px"
                        w="48px"
                        bg="#F2F2F2"
                        borderRadius="12px"
                        align="center"
                        justify="center"
                      >
                        <IconJpg />
                      </Flex>
                      <Flex flexDir="column" gap="2px" align="center">
                        <CustomText
                          text="Aqama_front.jpg"
                          size="14px"
                          color="yess.neutral700"
                        />
                        <CustomText
                          text="12 Kbs"
                          size="12px"
                          color="yess.neutral500"
                        />
                      </Flex>
                      <CustomButton
                        btnTitle="View"
                        maxW="79px"
                        height="32px"
                        bg="#EDF3FF"
                        border="1px solid"
                        borderColor="#387DF5"
                        radius="8px"
                        color="#387DF5"
                        size="14px"
                        weight="400"
                      />
                    </Flex>
                    <Flex
                      p="16px 24px"
                      flexDir="column"
                      align="center"
                      gap="12px"
                      bg="rgba(242, 242, 242, 0.50)"
                      borderRadius="16px"
                      w="100%"
                    >
                      <Flex
                        h="48px"
                        w="48px"
                        bg="#F2F2F2"
                        borderRadius="12px"
                        align="center"
                        justify="center"
                      >
                        <IconJpg />
                      </Flex>
                      <Flex flexDir="column" gap="2px" align="center">
                        <CustomText
                          text="Aqama_back.jpg"
                          size="14px"
                          color="yess.neutral700"
                        />
                        <CustomText
                          text="12 Kbs"
                          size="12px"
                          color="yess.neutral500"
                        />
                      </Flex>
                      <CustomButton
                        btnTitle="View"
                        maxW="79px"
                        height="32px"
                        bg="#EDF3FF"
                        border="1px solid"
                        borderColor="#387DF5"
                        radius="8px"
                        color="#387DF5"
                        size="14px"
                        weight="400"
                      />
                    </Flex>
                  </Flex>
                )}
              </Flex>
            </Flex>
          </Box>
          <Box display={user?.badge ? "flex" : "none"}>
            <InviteCard isLoading={!user} user={user} />
          </Box>
        </Flex>
      </CustomCard>
    </>
  );
}

export default Dashboard;
